

export enum FontSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
  XLarge = 'XLarge',
}

// FontSize unit is rem
export const FontSizeValue = {
  Small: 1,
  Medium: 1.125,
  Large: 1.25,
  XLarge: 1.5,
};

interface FontSizeItem {
  fontSize: number;
  marginY: number;
}

export interface FontSizeItems {
  normal: FontSizeItem;
  heading1: FontSizeItem;
  heading2: FontSizeItem;
  heading3: FontSizeItem;
}

export const getFontSizeValues = (fontSize: FontSize): FontSizeItems => {
  // heading spacing default
  const headingSpacings = {
    Small: 0.25,
    Medium: 0.5,
    Large: 0.75,
    XLarge: 1,
  };

  const normalSize = FontSizeValue[fontSize];
  const heading3 = normalSize + 0.25;
  const heading2 = normalSize + 0.5;
  const heading1 = heading2 + 0.5;

  return {
    normal: {
      fontSize: normalSize,
      marginY: 0,
    },
    heading1: {
      fontSize: heading1,
      marginY: headingSpacings[fontSize] + 0.25,
    },
    heading2: {
      fontSize: heading2,
      marginY: headingSpacings[fontSize],
    },
    heading3: {
      fontSize: heading3,
      marginY: headingSpacings[fontSize],
    },
  };
};
